import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { OrderModel } from "../models/OrderModel";
import { ConfigClass } from "./../config";

@Injectable({
  providedIn: "root"
})
export class TimelineService {
  // Base url
  baseurl = ConfigClass.getEndpoint;

  // get token fromm storage
  token = JSON.parse(sessionStorage.getItem("currentUser"));

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({})
  };

  constructor(private http: HttpClient) {
    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Content-Type",
      "application/json"
    );
  }

  // GET
  getAllTimelines(filters): Observable<any> {
    return this.http
      .get<OrderModel>(
        this.baseurl +
        "/timeslines/all?page=" +
        filters.page +
        "&size=" +
        filters.size +
        "&description=" +
        filters.description +
        "&type=" +
        filters.type +
        "&createdDate=" +
        filters.createdDate,
        this.httpOptions
      )
      .pipe(
        catchError(this.errorHandl)
      );
  }

  // DELETE
  deleteTimeline(id) {
    return this.http
      .delete<OrderModel>(this.baseurl + "/timeslines/" + id, this.httpOptions)
      .pipe(
        catchError(this.errorHandl)
      );
  }

  updateTimeline(obj: any, id) {

    let httpOptions = {
      headers: new HttpHeaders({})
    };

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    let data: any = new FormData();
    try {
      data.append("type", obj.type);
      data.append("descriptionAr", obj.descriptionAr);
      data.append("description", obj.description);

      if (obj.primaryImageFile) {
        data.append("primaryImage", obj.primaryImageFile);
      }

      return this.http
        .put<OrderModel>(this.baseurl + "/timeslines/" + id, data, httpOptions)
        .pipe(
          catchError(this.errorHandl)
        );
    } catch (ex) {
    }
  }

  addNewTimeline(obj: any) {

    let httpOptions = {
      headers: new HttpHeaders({})
    };

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    let data: any = new FormData();
    try {
      data.append("type", obj.type);
      data.append("descriptionAr", obj.descriptionAr);
      data.append("description", obj.description);

      if (obj.primaryImageFile) {
        data.append("primaryImage", obj.primaryImageFile);
      }

      return this.http
        .post<OrderModel>(this.baseurl + "/timeslines", data, httpOptions)
        .pipe(
          catchError(this.errorHandl)
        );
    } catch (ex) {
    }
  }

  DeleteImage(id, ImageID) {

    let httpOptions = {
      headers: new HttpHeaders({})
    };

    this.httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    return this.http
      .delete<OrderModel>(this.baseurl + "/offers/" + id + "/images/" + ImageID, httpOptions)
      .pipe(

        catchError(this.errorHandl)
      );
  }


  getImage(path) {

    let httpOptions: any = {
      headers: new HttpHeaders({}),
    };

    httpOptions.headers = this.httpOptions.headers.set(
      "Authorization",
      "bearer " + this.token
    );

    httpOptions.headers = this.httpOptions.headers.set(
      "Content-Type",
      "application/json"
    );

    httpOptions.responseType = "arraybuffer";

    return this.http
      .get<any>(
        this.baseurl +
        "/images/getImage?imagePath=" + path,
        httpOptions
      )
      .pipe(

        catchError(this.errorHandl)
      );
  }

  // Error handling
  errorHandl(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
